// THIS FILE IS GENERATED AUTOMATICALLY

import dashboardV2 from "./dashboardV2";
import news from "./news";
import knowledgeBaseV2 from "./knowledgeBaseV2";
import idd from "./idd";
import trainingsV2 from "./trainingsV2";
import trainingV2 from "./trainingV2";
import onboarding from "./onboarding";
import videoPlayer from "./videoPlayer";
import notifications from "./notifications";
import competence from "./competence";
import teamIndicators from "./teamIndicators";
import gamification from "./gamification";
import certificates from "./certificates";
import profile from "./profile";
import scrollLesson from "./scrollLesson";
import anonSurvey from "./anonSurvey";
import form from "./form";
import provisions from "./provisions";
import { ProfileCompetenceList } from "./competence/components/profileCompetenceList/profileCompetenceList.component.js";
import { VideoSection } from "./videoPlayer/components/videoSection/videoSection.component.js";

export const Modules = {
  dashboardV2,
  news,
  knowledgeBaseV2,
  idd,
  trainingsV2,
  trainingV2,
  onboarding,
  videoPlayer,
  notifications,
  competence,
  teamIndicators,
  gamification,
  certificates,
  profile,
  scrollLesson,
  anonSurvey,
  form,
  provisions,
};

export const ModuleType = {
  DashboardV2: "dashboardV2",
  News: "news",
  KnowledgeBaseV2: "knowledgeBaseV2",
  Idd: "idd",
  TrainingsV2: "trainingsV2",
  TrainingV2: "trainingV2",
  Onboarding: "onboarding",
  VideoPlayer: "videoPlayer",
  Notifications: "notifications",
  Competence: "competence",
  TeamIndicators: "teamIndicators",
  Gamification: "gamification",
  Certificates: "certificates",
  Profile: "profile",
  ScrollLesson: "scrollLesson",
  AnonSurvey: "anonSurvey",
  Form: "form",
  Provisions: "provisions",
};

export const Widgets = {
  ProfileCompetenceList,
  VideoSection,
};

export const WidgetType = {
  ProfileCompetenceList: "ProfileCompetenceList",
  VideoSection: "VideoSection",
};
